import React, { useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, Grid } from '@material-ui/core';
import EnhancedTableToolbar from '../common/table/EnhancedTableToolbar';

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3),
    overflowX: 'auto',
    margin: 'auto',
    padding: '5px'
  }
}));

const Browse = props => {
  const classes = useStyles();
  const { ids } = useParams();
  let history = useHistory();
  const selectedIds = (ids && ids.split(',')) || [];
  const last = selectedIds.length > 0 ? selectedIds[selectedIds.length - 1] : null;
  const [selectedId, setSelectedId] = useState(last);
  const [page, setPage] = useState(0);
  const [selectedMetrics, setSelectedMetrics] = useState([]);
  const [selectedPath, setSelectedPath] = useState(null);

  const { TreeComponent, BreadcrumbPathComponent, MetricsTableComponent, baseUrl, title } = props;

  const onItemSelected = (path, nodeId) => {
    history.replace(`${baseUrl}${path.map(p => p.id).join(',')}`);
    setSelectedPath(path);
    setSelectedId(nodeId);
    setPage(0);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <Paper className={classes.root}>
          <EnhancedTableToolbar
            title={title}
            numSelected={selectedMetrics.filter(m => m.selected).length}
            tooltip={selectedMetrics
              .filter(m => m.selected)
              .map(m => m.name)
              .join('; ')}
            linkTo={`/metric/${selectedMetrics
              .filter(m => m.selected)
              .map(m => `${m.id}`)
              .join(',')}`}
            linkText='view in chart'
            onClear={() => setSelectedMetrics(selectedMetrics.map(m => ({ selected: false, id: m.id, name: m.name, geographies: m.geographies })))}
          />
          <TreeComponent initiallySelectedNodeIds={selectedIds} selectedNodeId={selectedId} onItemSelected={onItemSelected} />
        </Paper>
      </Grid>
      <Grid item xs={6}>
        {selectedId && (
          <Paper className={classes.root}>
            <BreadcrumbPathComponent path={selectedPath} initiallySelectedIds={selectedIds} />
            <MetricsTableComponent
              page={page}
              setPage={setPage}
              selectedId={selectedId}
              selectedMetrics={selectedMetrics}
              onMetricsSelected={setSelectedMetrics}
            />
          </Paper>
        )}
      </Grid>
    </Grid>
  );
};

export default Browse;
